<div #parent class="dropdown-wrapper" (click)="preventClick($event)">
  <button 
    class="button-wrapper" 
    #button 
    unhClickedOut
    [class.open]="isOpen " 
    [class.openMobile]="isMobile && isOpen" 
    [enable]="isOpen" 
    (clickedout)="handleClickedOut($event)"
    (click)="handleButtonTrigger()"
    >
    <mat-icon svgIcon="unh_config"></mat-icon>
    <span
      *ngIf="!isMobile || (isMobile && isOpen && showTitleTextMobile) || (isMobile && !isOpen && showTitleTextMobile)   "
      class="button-title">{{optionsHoverText}}</span>
  </button>
  <div *ngIf="isOpen" class="content-wrapper">
    <ul>
      <li *ngFor="let item of items" 
        (click)="item.options?.highlight ? unHighilghtItem(item) : selectOption(item)">
        <div
         class="item-wrapper">
          <div *ngIf="item.icon " class="item-icon" [class.pinned]="item?.options?.highlight">
            <mat-icon svgIcon="{{item.icon}}"></mat-icon>
          </div>
          <span class="item-title">{{item.name}}</span>
        </div>
      </li>
    </ul>
  </div>
</div>
